import React from 'react';
import SelectBox from './SelectBox';

const Popup = ({ 
    isOpen, 
    onClose, 
    title, 
    subtitle, 
    fields = [],
    secondFields = [],
    onFieldChange, 
    onSecondFieldChange = () => {}, 
    onFieldBlur = () => {}, 
    onSecondFieldBlur = () => {}, 
    onSubmit, 
    onSecondSubmit = () => {},  
    submitButtonLabel = 'Submit',  
    secondSubmitButtonLabel = 'Submit',
    usedBagsError = false, // Новый пропс для ошибки Used Bags
    usedBagsErrorMsg = '' // Новый пропс для сообщения об ошибке
}) => {
    if (!isOpen) return null;

    const formatFieldValue = (field) => {
        if (field.type === 'date' && field.value) {
            return field.value; 
        } else if (field.type === 'date' && !field.value) {
            return '';
        }
        return field.value;
    };

    const renderCustomField = (field, index) => {
        if (field.type === 'custom') {
            return (
                <div key={index} className="popup__custom-field">
                    {field.value}
                </div>
            );
        }
        return null;
    };

    const renderField = (field, index, onChange, onBlur) => {
        if (field.hidden) {
            return null;
        }

        const isRequired = field.required && !field.disabled;

        if (field.type === 'checkbox') {
            return (
                <div key={index} className="popup__inputs--columns">
                    <label className="label">
                        <input
                            className="form__checkbox"
                            type="checkbox"
                            name={field.name}
                            checked={!!field.value}
                            onChange={(e) =>
                                onChange(index, {
                                    target: { 
                                        value: e.target.checked ? 1 : 0,
                                        type: 'checkbox',
                                        checked: e.target.checked 
                                    },
                                })
                            }
                        />
                        {field.label}
                    </label>
                </div>
            );
        }

        if (field.type === 'custom') {
            return renderCustomField(field, index);
        }

        if (field.type === 'label') {
            if (field.hideEmpty && !field.value) return null; // e.g. box size: shown only once known
            return (
                <div key={index} className={`popup__label ${field.className || ''}`}>
                    <label className="label">{field.label}</label>
                    <span>{field.value !== undefined ? field.value : 'N/A'}</span>
                </div>
            );
        }

        return (
            <div key={index} className={`popup__inputs--columns ${field.className || ''}`}>
                <label className="label">{field.label}</label>
                {field.type === 'select' ? (
                    <SelectBox
                        key={`${field.name}-${index}`}
                        tableName={field.tableName}
                        displayField={field.displayField}
                        updateField={field.updateField}
                        selectedValue={field.value}
                        onChange={(value) => onChange(index, { target: { value } })}
                    />
                ) : (
                    <input
                        className="form__input"
                        type={field.type || 'text'}
                        name={field.name}
                        value={formatFieldValue(field) || ''}
                        readOnly={field.readOnly}
                        disabled={field.disabled || false}
                        required={field.required || false}
                        onChange={(e) => onChange(index, e)}
                        onBlur={(e) => onBlur && onBlur(index, e)}
                    />
                )}
            </div>
        );
    };

    return (
        <div className={`popup ${isOpen ? 'open' : ''}`}>
            <div className="popup__body">
                <div className="popup__content">
                    <button className="popup__close-button" onClick={onClose}>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <use xlinkHref="#closeBtn"></use>
                        </svg>
                    </button>

                    <h2 className="popup__title">{title}</h2>
                    <h3 className="popup__subtitle">{subtitle}</h3>

                    <div className="popup__forms--row">
                        {/* Первая форма */}
                        <form className="popup__inputs--column" onSubmit={onSubmit}>
                            {Array.isArray(fields) &&
                                fields.map((field, index) =>
                                    renderField(field, index, onFieldChange, onFieldBlur)
                                )}
                            <button type="submit" className="btn btn__green mt-15">
                                {submitButtonLabel}
                            </button>
                        </form>

                        {/* Вторая форма (опциональная) */}
                        {Array.isArray(secondFields) && secondFields.length > 0 && (
                            <form
                                className="popup__inputs--column"
                                onSubmit={onSecondSubmit}
                            >
                                {secondFields.map((field, index) =>
                                    renderField(field, index, onSecondFieldChange, onSecondFieldBlur)
                                )}
                                
                                {/* Сообщение об ошибке Used Bags */}
                                {usedBagsError && usedBagsErrorMsg && (
                                    <div className="popup__error-message" 
                                         style={{
                                             color: 'red',
                                             backgroundColor: '#ffe6e6',
                                             border: '1px solid red',
                                             padding: '10px',
                                             borderRadius: '4px',
                                             marginTop: '15px',
                                             fontSize: '14px'
                                         }}>
                                        <strong>Used Bags Validation Error:</strong>
                                        <p>{usedBagsErrorMsg}</p>
                                    </div>
                                )}
                                
                                <button 
                                    type="submit" 
                                    className="btn btn__green mt-15"
                                    style={{
                                        border: usedBagsError ? '1px solid #218838' : 'none'
                                    }}
                                >
                                    {secondSubmitButtonLabel}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;